define([
	"dojo/_base/declare",
	"csi/heading/Attribute",
	"csi/html",
	"csi/reflection",
	"csi/session"
], function(declare,Attribute,html,reflection,session) {

	return declare(Attribute, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			var	rc = reflection.getClass(value);
			return rc ? rc.getAlias() : value;
		},
		
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML
			var s = this._getValue(ctx, h);
			var	rc = reflection.getClass(s);
			if (!rc) {
				return this.inherited(arguments);
			}

			html.create("a", {
				"class": html.CSS_BROWSE,
				href: session.getLocationForUrl(rc.getBusinessObject()),
				innerText: rc.getAlias()
			}, refNode);

			return true;
		}
	});
});